/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProposalSummaryEffectiveAnnualCostFigures } from './ProposalSummaryEffectiveAnnualCostFigures';
import {
    ProposalSummaryEffectiveAnnualCostFiguresFromJSON,
    ProposalSummaryEffectiveAnnualCostFiguresFromJSONTyped,
    ProposalSummaryEffectiveAnnualCostFiguresToJSON,
} from './ProposalSummaryEffectiveAnnualCostFigures';

/**
 * 
 * @export
 * @interface ProposalSummaryEffectiveAnnualCost
 */
export interface ProposalSummaryEffectiveAnnualCost {
    /**
     * 
     * @type {ProposalSummaryEffectiveAnnualCostFigures}
     * @memberof ProposalSummaryEffectiveAnnualCost
     */
    investmentManagementCharges: ProposalSummaryEffectiveAnnualCostFigures;
    /**
     * 
     * @type {ProposalSummaryEffectiveAnnualCostFigures}
     * @memberof ProposalSummaryEffectiveAnnualCost
     */
    adviceCharges: ProposalSummaryEffectiveAnnualCostFigures;
    /**
     * 
     * @type {ProposalSummaryEffectiveAnnualCostFigures}
     * @memberof ProposalSummaryEffectiveAnnualCost
     */
    administrationCharges: ProposalSummaryEffectiveAnnualCostFigures;
    /**
     * 
     * @type {ProposalSummaryEffectiveAnnualCostFigures}
     * @memberof ProposalSummaryEffectiveAnnualCost
     */
    otherCharges: ProposalSummaryEffectiveAnnualCostFigures;
    /**
     * 
     * @type {ProposalSummaryEffectiveAnnualCostFigures}
     * @memberof ProposalSummaryEffectiveAnnualCost
     */
    total: ProposalSummaryEffectiveAnnualCostFigures;
}

/**
 * Check if a given object implements the ProposalSummaryEffectiveAnnualCost interface.
 */
export function instanceOfProposalSummaryEffectiveAnnualCost(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "investmentManagementCharges" in value;
    isInstance = isInstance && "adviceCharges" in value;
    isInstance = isInstance && "administrationCharges" in value;
    isInstance = isInstance && "otherCharges" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function ProposalSummaryEffectiveAnnualCostFromJSON(json: any): ProposalSummaryEffectiveAnnualCost {
    return ProposalSummaryEffectiveAnnualCostFromJSONTyped(json, false);
}

export function ProposalSummaryEffectiveAnnualCostFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryEffectiveAnnualCost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'investmentManagementCharges': ProposalSummaryEffectiveAnnualCostFiguresFromJSON(json['InvestmentManagementCharges']),
        'adviceCharges': ProposalSummaryEffectiveAnnualCostFiguresFromJSON(json['AdviceCharges']),
        'administrationCharges': ProposalSummaryEffectiveAnnualCostFiguresFromJSON(json['AdministrationCharges']),
        'otherCharges': ProposalSummaryEffectiveAnnualCostFiguresFromJSON(json['OtherCharges']),
        'total': ProposalSummaryEffectiveAnnualCostFiguresFromJSON(json['Total']),
    };
}

export function ProposalSummaryEffectiveAnnualCostToJSON(value?: ProposalSummaryEffectiveAnnualCost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InvestmentManagementCharges': ProposalSummaryEffectiveAnnualCostFiguresToJSON(value.investmentManagementCharges),
        'AdviceCharges': ProposalSummaryEffectiveAnnualCostFiguresToJSON(value.adviceCharges),
        'AdministrationCharges': ProposalSummaryEffectiveAnnualCostFiguresToJSON(value.administrationCharges),
        'OtherCharges': ProposalSummaryEffectiveAnnualCostFiguresToJSON(value.otherCharges),
        'Total': ProposalSummaryEffectiveAnnualCostFiguresToJSON(value.total),
    };
}

